import { useDataChange } from 'Simple/Data.js'
export function useOnChange(props) {
  let change = useDataChange({
    viewPath: props.viewPath,
    context: 'selected',
    path: 'event.actionData.actions',
  })
  return function onChange() {
    change([{ id: 'letter', document_template_id: null }])
  }
}
